import styled from 'styled-components';
import { Icon, Image, Text } from '@qwkin/components';

export const SideMenuItem = styled.div`
  display: flex;
  flex-direction: column;
  color: #333333;
  padding: 8px;
  align-items: center;
  justify-content: start;
  margin-left: 8px;
  text-align: center;

  &:hover {
    background: ${p => p.theme.color.primary.translucid};
    cursor: pointer;
    border-radius: 5px 0 0 5px;
  }

  &.active {
    background: ${p => p.theme.color.primary.translucid};
    cursor: pointer;
    border-right: 3px solid ${p => p.theme.color.primary.default};
    border-radius: 5px 0 0 5px;
  }

  @media screen and (max-width: 1024px) {
    margin-left: 8px;
  }
`;

export const NavbarText = styled(Text)`
  @media screen and (max-width: 1024px) {
    display: none;
  }
`;

export const MenuText = styled(Text)`
  @media screen and (max-width: 1024px) {
    display: none;
  }

  @media screen and (max-height: 750px) {
    display: none;
  }
`;

export const Logo = styled(Image)`
  margin-top: 8px;
  margin-left: 8px;
  width: 48px;
  border-radius: 30px;
`;

export const PlainSidemenu = styled.div`
  position: fixed;
  top: 0;
  width: 110px;
  background: white;
  height: 100%;
  z-index: 100;
  text-align: center;
  box-shadow: 0px 3px 6px #00000029;

  @media screen and (max-width: 1024px) {
    width: 70px;
  }
`;

export const DividerContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  padding: 0;
  margin: 0;
`;

export const SidemenuIcon = styled(Icon)`
  font-size: 28px;

  @media screen and (max-height: 850px) {
    font-size: 24px;
  }
`;
